import React from "react";
import ScheduleWidgetRow from "../ScheduleWidgetRow";
import getTime from "../../helpers/getTime";
import useSchedule from "../../hooks/useSchedule";

const ScheduleWidgetTable = () => {
  const schedule = useSchedule();
  const styles = [
    {
      titleClassName: "text-aqua",
    },
    {
      titleClassName: "text-cream",
    },
    {
      titleClassName: "text-gray-300",
    },
  ];

  return (
    <div className="flex flex-wrap mt-4">
      {schedule
        .filter(
          (item) => getTime(new Date(item.timeStart).toISOString()) >= getTime()
        )
        .slice(0, 3)
        .map((item, key) => (
          <div className="w-full my-4" key={key}>
            <ScheduleWidgetRow
              titleClassName={styles[key].titleClassName}
              {...item}
            />
          </div>
        ))}
    </div>
  );
};

export default ScheduleWidgetTable;
